<ul class="nav nav-tabs" [ngClass]="{ hScroll: hScroll, marginTop }" [id]="tabId">
  <li class="nav-item" *ngFor="let tab of tabs; let i = index">
    <div class="nav-link d-flex align-items-center gap-1" (click)="selectTab(i)" href="javascript:void(0)"
      [ngClass]="{ active: selectedIndex === i }">
      @if (tabLabel) {
      <ng-container *ngTemplateOutlet="tabLabel; context: { $implicit: tab }"></ng-container>
      } @else {
      <div class="tab-label-wrapper d-flex align-items-center justify-content-center gap-2 position-relative">
        <span class="fs-16 tab-menu-size">{{ tab.label }}</span>
        @if(hasValues[i]){
        <span><i class="fas fa-circle tab-icon position-absolute"></i></span>
        }
      </div>

      } @if(tab.badgeCount !== undefined && tab.badgeCount !== null){
      <span class="badge-container" [matTooltip]="
          (tab?.badgeCount ?? 0) > 10000 ? tab.badgeCount.toString() : ''
        ">
        {{ (tab?.badgeCount ?? 0) > 10000 ? "10000+" : tab?.badgeCount ?? 0 }}
      </span>
      }
    </div>
  </li>
</ul>